import { LoadLists } from "~/components/admin/dispatch";
import PageMeta from "~/components/common/meta";

export const ScreenLoadLists = () => {
  return (
    <>
      <PageMeta title="Load Lists | Art Handler" description="Load Lists" />
      <LoadLists />
    </>
  );
};
